import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, isRef as _isRef, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Teleport as _Teleport, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7c0467c8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "timeline" }
const _hoisted_2 = { class: "timelineInfo" }
const _hoisted_3 = { class: "versionPopover" }
const _hoisted_4 = { class: "searchBar" }
const _hoisted_5 = { class: "versionList" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = { class: "thumbnail" }
const _hoisted_8 = ["src"]
const _hoisted_9 = { class: "content" }
const _hoisted_10 = ["title"]
const _hoisted_11 = ["innerHTML"]
const _hoisted_12 = { class: "version" }
const _hoisted_13 = { class: "currentLineNode" }
const _hoisted_14 = { class: "nodeName" }
const _hoisted_15 = { class: "currentTime" }

import { ref, watch, Ref, getCurrentInstance, computed } from "vue";
  import * as Cesium from 'cesium';
  import { GeoTimeScale } from "@zjugis/geo-timeline";
  import { useStore } from 'vuex';

  
export default /*#__PURE__*/_defineComponent({
  __name: 'TimeLine',
  props: {
    viewer: {
      type: Cesium.Viewer,
    }
  },
  setup(__props) {

const props = __props;

  const store = useStore();
  const state = store.state;
  
  const visibleValue = computed(() => state.timelineStore.visible);
  const drawerVisible = computed(() => state.sidebarStore.drawerVisible);
  const currentTimeValue = computed(() => parseInt(state.timelineStore.currentTime));
  const inputTime = ref(250);

  const refreshCurrentTime = (v) => {
    if (v && /^-?\d*(\.\d+)?$/.test(v)) {
      store.commit('timelineStore/setCurrentTime', parseInt(v));
    }
  }

  const TimeScaleVersions = [{
    name: 'GTS2020',
    desc: 'GTS2020 means"A geologic time scale 2020",which has 1380 triples.Covers the geological duration from 0 to 542 Ma. Includes 153 Geochronologic era in total.<br/>Cited from(Gradstein, F.M., Ogg, J.G., Schmitz, M.D., & Ogg, G.M. (Eds.). (2020).Geologic time scale 2020. Elsevier.) ',
    image: 'https://resource.deep-time.org/resource/mapViewPic/ICS2020.png',
    data: "./GTS_2020.json"
  }];

  const instance = getCurrentInstance();
  const eb = instance?.appContext.config.globalProperties.$EventBus;

  let timescaleRef: Ref<HTMLElement | null> = ref(null);
  let timelineRef: Ref<HTMLElement | null> = ref(null);
  let selectedVersion = ref(TimeScaleVersions[0]);
  let versionKeywords = ref("");

  const removeHistoricalLayer = (onlyFirst = true) => {
    let viewer = props.viewer;
    const len = viewer.imageryLayers.length
    if (onlyFirst) {
      for (let i = 1; i < len; i++) {
        if (viewer.imageryLayers.get(i).imageryProvider.url.indexOf('historical') > -1) {
          viewer.imageryLayers.remove(viewer.imageryLayers.get(i));
          return
        }
      }
    } else {
      for (let i = len - 1; i >= 0; i--) {
        if (viewer.imageryLayers.get(i).imageryProvider.url.indexOf('historical') > -1) {
          viewer.imageryLayers.remove(viewer.imageryLayers.get(i));
        }
      }
    }
  }

  const changeBaseLineLayer = (time) => {
    let viewer = props.viewer;
    let t = parseInt(time);
    t = t < 0 ? 0 : t;
    t = t > 250 ? 250 : t;
    let layer: any = {
      url: `/historical/v2/${t}.webp`
    };
    if (viewer.imageryLayers.length > 10) {
      removeHistoricalLayer();
    }
    if (viewer.imageryLayers.length > 0 && viewer.imageryLayers.get(0).imageryProvider.url.indexOf('historical') == -1) {
      // 底图不是历史图层，切换底图
      viewer.imageryLayers.remove(viewer.imageryLayers.get(0));
    }
    viewer.imageryLayers.addImageryProvider(new Cesium.SingleTileImageryProvider(layer));
  };
  
  const createTimescale = (version) => {
    const { data } = version;
    const oldGeoTimeScale = store.state.timelineStore.geoTimeScale;
    const initStage = oldGeoTimeScale ? oldGeoTimeScale.stage : 'Mesozoic';

    timescaleRef.value && (timescaleRef.value.innerHTML = "");

    fetch(data).then(async res => {
      const intervals = await res.json()
      const geoTimeScale = new GeoTimeScale(timescaleRef.value, intervals, {
        simplify: true,
        height: 70,

        onChange: (val) => {
          const { start } = val.data;
          store.commit('timelineStore/setCurrentTime', start);
        },

        onDrag: (time) => {
          store.commit('timelineStore/setCurrentTime', time);
        }
      });
      geoTimeScale.stage = initStage
      store.commit('timelineStore/setGeoTimeScale', geoTimeScale);
      store.commit('timelineStore/setCurrentTime', currentTimeValue.value);
    })
  };
  
  const onBtnClick = () => {
    const v = visibleValue.value;
    store.commit('timelineStore/setVisible', !v);
  };
  
  const onVerionItemClick = version=> {
    selectedVersion.value = version;
    // createTimeline(version);
    createTimescale(version);
  }

  const updateTerrainProvider = (t) => {
    if (state.timelineStore.dem) {
      let viewer = props.viewer;
      viewer.scene.terrainProvider = new Cesium.CesiumTerrainProvider({
        url: store.state.timelineStore.demUrl + "/" + parseInt(t),
        requestWaterMask: true,
      });
    }
  }

  watch(currentTimeValue, (newValue, oldValue) => {
    if (newValue != oldValue && state.timelineStore.visible) {
      const v = newValue > 0 ? newValue : 0.001;
      changeBaseLineLayer(newValue);
      // store.state.timelineStore.geoTimeLine.time = newValue;
      store.state.timelineStore.geoTimeScale.time = v;
      updateTerrainProvider(parseInt(newValue));
      inputTime.value = newValue;
    }
  });

  watch(visibleValue, (v) => {
    if (!v) {
      eb.emit('timeline.remove');
      store.commit('timelineStore/reset');
      removeHistoricalLayer(false);
    } else {
      selectedVersion.value = TimeScaleVersions[0];
      // createTimeline(TimeScaleVersions[0]);
      createTimescale(TimeScaleVersions[0]);
    }
  });

  watch(drawerVisible, (v) => {
    if (!visibleValue.value) {
      return
    }
    if (v) {
      createTimescale(TimeScaleVersions[0]);
    } else {
      createTimescale(TimeScaleVersions[0]);
    }
  })

return (_ctx: any,_cache: any) => {
  const _component_Search = _resolveComponent("Search")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_scrollbar = _resolveComponent("el-scrollbar")!
  const _component_Menu = _resolveComponent("Menu")!
  const _component_el_popover = _resolveComponent("el-popover")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: _normalizeClass(["geotimeline", { visible: visibleValue.value }]),
      onClick: onBtnClick
    }, null, 2),
    (visibleValue.value)
      ? (_openBlock(), _createBlock(_Teleport, {
          key: 0,
          to: "#cesium-container"
        }, [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createVNode(_component_el_popover, {
                placement: "bottom-start",
                width: 370,
                "popper-style": { zIndex: 3000, padding: 0 },
                offset: 3,
                "popper-options": { modifiers: [{ name: 'arrow', options: { padding: { right: 320 } } }] },
                trigger: "click"
              }, {
                reference: _withCtx(() => [
                  _createElementVNode("div", _hoisted_12, [
                    _createVNode(_component_el_icon, {
                      color: "#fff",
                      size: 12
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_Menu)
                      ]),
                      _: 1
                    }),
                    _createTextVNode(" " + _toDisplayString(_unref(selectedVersion).name), 1)
                  ])
                ]),
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_3, [
                    _createElementVNode("div", _hoisted_4, [
                      _createVNode(_component_el_input, {
                        modelValue: _unref(versionKeywords),
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(versionKeywords) ? (versionKeywords).value = $event : versionKeywords = $event)),
                        placeholder: "Enter keywords",
                        class: "input-with-select"
                      }, {
                        append: _withCtx(() => [
                          _createVNode(_component_el_icon, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_Search)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]),
                    _createVNode(_component_el_scrollbar, { height: 500 }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_5, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(TimeScaleVersions.filter(o=>o.name.includes(_unref(versionKeywords))), (version) => {
                            return (_openBlock(), _createElementBlock("div", {
                              key: version.name,
                              class: _normalizeClass(["versionItem", {active:_unref(selectedVersion).name == version.name}]),
                              onClick: ($event: any) => (onVerionItemClick(version))
                            }, [
                              _createElementVNode("div", _hoisted_7, [
                                _createElementVNode("img", {
                                  src: version.image,
                                  onerror: "this.src=https://resource.deep-time.org/resource/mapViewPic/Thumbnail.png"
                                }, null, 8, _hoisted_8)
                              ]),
                              _createElementVNode("div", _hoisted_9, [
                                _createElementVNode("h4", null, _toDisplayString(version.name), 1),
                                _createElementVNode("div", {
                                  class: "desc",
                                  title: version.desc.replaceAll('<br/>','\n')
                                }, [
                                  _createElementVNode("label", null, _toDisplayString(version.name) + ": ", 1),
                                  _createTextVNode(),
                                  _createElementVNode("span", {
                                    innerHTML: version.desc
                                  }, null, 8, _hoisted_11)
                                ], 8, _hoisted_10)
                              ])
                            ], 10, _hoisted_6))
                          }), 128))
                        ])
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _: 1
              }),
              _createElementVNode("div", _hoisted_13, [
                _createElementVNode("div", _hoisted_14, [
                  _createTextVNode("Time: "),
                  _createVNode(_component_el_input, {
                    modelValue: inputTime.value,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((inputTime).value = $event)),
                    size: "small",
                    style: {"width":"60px","height":"20px"},
                    onChange: refreshCurrentTime
                  }, null, 8, ["modelValue"]),
                  _createTextVNode(" Ma ")
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_15, [
              _createElementVNode("span", null, _toDisplayString(parseInt(currentTimeValue.value)) + " Ma", 1)
            ]),
            _createElementVNode("div", null, [
              _createElementVNode("div", {
                ref_key: "timescaleRef",
                ref: timescaleRef,
                style: {"display":"grid"}
              }, null, 512),
              _createElementVNode("div", {
                ref_key: "timelineRef",
                ref: timelineRef,
                style: {"display":"grid"}
              }, null, 512)
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})